import trainingSearch from "../assets/mock-data/trainingSearch.json";
import applicationList from "../assets/mock-data/applications/applications.json";
import accountInformation from "../assets/mock-data/accounts/account.json";
import educationList from "../assets/mock-data/education/education.json";
import credentialList from "../assets/mock-data/credential/credential.json";
import employmentList from "../assets/mock-data/employment/employment.json";
import employmentTypesList from "../assets/mock-data/employment/employment-types.json";
import employmentJobTitlesList from "../assets/mock-data/employment/employment-job-titles.json";
import countiesList from "../assets/mock-data/employment/counties.json";
import collegesList from "../assets/mock-data/employment/colleges.json";
import organizationsSdaList from "../assets/mock-data/organizations/organizations-sda.json";
import programSearchList from "../assets/mock-data/employment/program-search.json";
import updatedInformation from "../assets/mock-data/updatedInformation.json";
import professionalDevelopmentList from "../assets/mock-data/professionalDevelopment/professionalDevelopmentList.json";
import ageGroupsList from "../assets/mock-data/employment/age-groups.json";
import employmentRowData from "../assets/mock-data/employment/employment-row.json";
import newHireFormSchema from "../assets/mock-data/organizations/new-hire-form-schema.json"
import MockAdapter from "axios-mock-adapter";

export const isMockEnabled = () => {
  // return true
  return process.env.NEXT_PUBLIC_AXIOS_MOCK_ENABLED === "true";
};

export const initializeAxiosMockAdapter = (instance) => {
  const mock = new MockAdapter(instance);
  mock.onPost("/api/TrainingSearch").reply(() => postTrainingSearch());
  mock.onGet(/\/applications\/get_all\/\d+/).reply(() => getApplications());
  mock.onGet(/\/account\?id=\d+/).reply(() => getAccountInformation());
  mock.onGet(/\/employment\?user_id=\d+/).reply(() => getEmployment());
  mock.onGet(/\/Employment_Types/).reply(() => getEmploymentTypes());
  mock.onGet(/\/Employment_Job_Titles/).reply(() => getEmploymentJobTitles());
  mock.onGet(/\/Age_Groups/).reply(() => getAgeGroups());
  mock.onGet(/\/Counties/).reply(() => getCounties());
  mock.onGet(/\/Colleges/).reply(() => getColleges());
  mock.onPut(/\/account\//).reply(() => putUpdatePersonalInformation());
  mock.onGet(/\/user\/get_user_education\/\d+/).reply(() => getEducation());
  mock.onGet(/\/api\/credentials\/\d+/).reply(() => getCredentials());
  mock.onGet(/\/api\/credential\/\d+/).reply(() => getCredential());
  mock
    .onGet(/\/user\/get_employment_row\?employment_id=\d+/)
    .reply(() => getEmploymentRowData());
  mock
    .onGet(/\/organizations\/Organizations\?sda=\d+/)
    .reply(() => getOrganizationsSda());
  mock.onGet(/^\/programs\/search(\?.*)?$/).reply(() => getPrograms());
  mock
    .onGet(/\/professional_development\?user_id=\d+/)
    .reply(() => getProfessionalDevelopment());
  mock.onGet(/\/api\/checklist\/form_schema_and_data_/).reply(() => getNewHireFormSchemaAndData());
  mock.onAny().passThrough()
};

const extractIdPathParamFromUrl = (config) => {
  return config.url.split("/").pop();
};

export const getApplications = () => {
  return [200, applicationList];
};

export const getAccountInformation = () => {
  return [200, accountInformation];
};

export const getEducation = () => {
  return [200, educationList];
};

export const getCredentials = () => {
  return [200, credentialList];
};

export const getCredential = () => {
  return [200, credentialList];
};

export const postTrainingSearch = () => {
  return [200, trainingSearch];
};

export const getEmployment = () => {
  return [200, employmentList];
};

export const getEmploymentTypes = () => {
  return [200, employmentTypesList];
};

export const getEmploymentJobTitles = () => {
  return [200, employmentJobTitlesList];
};

export const getCounties = () => {
  return [200, countiesList];
};

export const getColleges = () => {
  return [200, collegesList];
};

export const getOrganizationsSda = () => {
  return [200, organizationsSdaList];
};

export const getPrograms = () => {
  return [200, programSearchList];
};

export const putUpdatePersonalInformation = () => {
  return [200, updatedInformation];
};

export const getProfessionalDevelopment = () => {
  return [200, professionalDevelopmentList];
};

export const getAgeGroups = () => {
  return [200, ageGroupsList];
};

export const getEmploymentRowData = () => {
  return [200, employmentRowData];
};

export const getNewHireFormSchemaAndData = () => {
  return [200, newHireFormSchema];
};